import React from 'react';

const SynioLogo = ({ className = "", height = 40 }) => {
  return (
    <div className={className}>
      <svg 
        id="synio-logo" 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 227.05 70.26"
        style={{ 
          display: 'block',
          height: `${height}px`,
          width: 'auto'
        }}
      >
        <g id="c">
          <g>
            <path d="m124.04.27c-13.32,0-24.16,10.84-24.16,24.16v19.16c0,2.76,2.24,5,5,5s5-2.24,5-5v-19.16c0-7.81,6.35-14.16,14.16-14.16s14.16,6.35,14.16,14.16v19.16c0,2.76,2.24,5,5,5s5-2.24,5-5v-19.16c0-13.32-10.84-24.16-24.16-24.16Z"/>
            <path d="m84.88.45c-2.76,0-5,2.24-5,5v19.16c0,7.81-6.35,14.16-14.16,14.16s-14.16-6.35-14.16-14.16c0-2.76-2.24-5-5-5s-5,2.24-5,5c0,13.32,10.84,24.16,24.16,24.16,5.29,0,10.18-1.71,14.16-4.6v1.94c0,7.81-6.35,14.16-14.16,14.16-2.76,0-5,2.24-5,5s2.24,5,5,5c13.32,0,24.16-10.84,24.16-24.16v-19.16c0-.22-.04-.43-.07-.65.04-.56.07-1.12.07-1.69V5.45c0-2.76-2.24-5-5-5Z"/>
            <path d="m163.2.11c-2.76,0-5,2.24-5,5v38.65c0,2.76,2.24,5,5,5s5-2.24,5-5V5.11c0-2.76-2.24-5-5-5Z"/>
            <path d="m34.49.37h-12.79c-.15-.01-.3-.05-.46-.05C13.18.32,6.62,6.88,6.62,14.94s6.56,14.61,14.61,14.61c.03,0,.06,0,.09,0,.03,0,.06,0,.09,0,2.54,0,4.62,2.07,4.62,4.62s-2.07,4.61-4.62,4.61c-.04,0-.07,0-.11.01-.04,0-.07-.01-.11-.01H5c-2.76,0-5,2.24-5,5s2.24,5,5,5h16.2s.07,0,.11-.01c.04,0,.07.01.11.01,8.06,0,14.62-6.56,14.62-14.61s-6.56-14.62-14.62-14.62c-.03,0-.06,0-.09,0-.03,0-.06,0-.09,0-2.54,0-4.61-2.07-4.61-4.61s1.99-4.52,4.47-4.6c.11,0,.21.03.32.03h13.08c2.76,0,5-2.24,5-5S37.25.37,34.49.37Z"/>
            <path d="m202.62,0c-13.47,0-24.43,10.96-24.43,24.43s10.96,24.43,24.43,24.43,24.43-10.96,24.43-24.43S216.1,0,202.62,0Zm0,38.86c-7.96,0-14.43-6.47-14.43-14.43s6.47-14.43,14.43-14.43,14.43,6.47,14.43,14.43-6.47,14.43-14.43,14.43Z"/>
          </g>
          <circle cx="202.63" cy="24.43" r="2.5"/>
        </g>
      </svg>
    </div>
  );
};

export default SynioLogo;
